var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { bindable, computedFrom } from "aurelia-framework";
import { DataType, Query, QueryFilter, SavedQueriesDataModel, SourceType, ProjectionPropertyOrdering } from "../../../models/queries/queries.models";
import { CacheClient, CacheKeys, CacheLocation } from "../../../services/basics/client-caching.service";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../services/queries/queries-client.services";
import { CloneUtility } from "../../../utilities/clone";
import { Guid } from "../../../utilities/guid";
import { activationStrategy, Router } from "aurelia-router";
import { AllEntityTypeConfigurationConstants } from "../../../models/basics/basics.models";
import { DialogServiceConstants } from "../../../constants/basics/dialog.constants";
import { QueriesEditorEvents } from "./queries-editor-events";
import { I18N } from "aurelia-i18n";
import "moment";
import moment from "moment";
import { UserRoleAndClaimsHelper } from "../../../helpers/user-role-and-claims.helper";
import { UserClientService } from "../../../services/authentication/user-client.service";
import { Reflection } from "../../../utilities/reflection";
import { toNative } from "../../../utilities/promise-utils";
var QueriesEditor = /** @class */ (function () {
    function QueriesEditor(element, notificationService, queriesService, dialogClientService, router, cache, i18N, userClientService) {
        var _this = this;
        this.element = element;
        this.notificationService = notificationService;
        this.queriesService = queriesService;
        this.dialogClientService = dialogClientService;
        this.router = router;
        this.cache = cache;
        this.i18N = i18N;
        this.userClientService = userClientService;
        this.title = "";
        this.showDataGrid = true;
        this.showPreviewButton = false;
        this.pageCount = 100;
        this.limit = null;
        this.queryId = -1;
        this.clickMode = "double";
        this.hideGrouping = false;
        this.getParams = function (item) { return ({ id: item ? item.id : -1 }); };
        this.sortAlphabetically = true;
        this.fixedColumns = [];
        this.fixedFilters = [];
        this.selected = "panel-results";
        this.selectedFilters = [];
        this.activateInternalCalled = false;
        this.metaDataLoaded = false;
        this.pageChanged = function () {
            _this.dispatchEvent('page-changed');
        };
        this.queriesService.getEntityModels().then(function (models) {
            _this.models = models;
            _this.metaDataLoaded = true;
        });
    }
    QueriesEditor_1 = QueriesEditor;
    Object.defineProperty(QueriesEditor.prototype, "datagrid", {
        get: function () {
            return this._dataGrid;
        },
        set: function (value) {
            this._dataGrid = value;
            if (this._dataGrid) {
                this.dispatchEvent(QueriesEditorEvents.dataGridAvailable, this._dataGrid);
            }
            else {
                this.dispatchEvent(QueriesEditorEvents.dataGridNotAvailable);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueriesEditor.prototype, "columns", {
        get: function () {
            return this.selectedSavedQuery
                ? this.selectedSavedQuery.columns
                : this.savedQueries
                    ? this.savedQueries.filter(function (sq) { return sq.queryId == -1; })[0].columns
                    : [];
        },
        set: function (columns) {
            if (this.selectedSavedQuery) {
                this.selectedSavedQuery.columns = columns;
            }
            else {
                this.savedQueries.filter(function (sq) { return sq.queryId == -1; })[0].columns = columns;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueriesEditor.prototype, "selectedSavedQuery", {
        get: function () {
            return this._selectedSavedQuery;
        },
        set: function (value) {
            if (this._selectedSavedQuery && value &&
                this._selectedSavedQuery.queryId == value.queryId) {
                return;
            }
            this._selectedSavedQuery = value;
            this.selectedSavedQueryChanged();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueriesEditor.prototype, "dataGridClass", {
        get: function () {
            return this.selectedModel ? Reflection.kebabCase(this.selectedModel.uri) : null;
        },
        enumerable: false,
        configurable: true
    });
    QueriesEditor.prototype.queryIdChanged = function () {
        var _this = this;
        if (this.savedQueries) {
            var queriesFound = this.savedQueries.filter(function (z) { return z.queryId == _this.queryId; });
            this.selectedSavedQuery =
                queriesFound.length > 0 ? queriesFound[0] : null;
        }
        else {
            this.selectedSavedQuery = null;
        }
    };
    Object.defineProperty(QueriesEditor.prototype, "isEditorVisible", {
        get: function () {
            return (this.editorAnchor &&
                this.editorAnchor.classList.contains("active") &&
                this.hasSharedGloballyPermission());
        },
        enumerable: false,
        configurable: true
    });
    QueriesEditor.prototype.addEventListener = function (eventName, func) {
        this.element.addEventListener(eventName, func);
    };
    QueriesEditor.prototype.removeEventListener = function (eventName, func) {
        this.element.removeEventListener(eventName, func);
    };
    QueriesEditor.prototype.getDataGrid = function () {
        return this.datagrid;
    };
    QueriesEditor.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    QueriesEditor.prototype.showColumnOptions = function () {
        if (!window["SystemJS"]) {
            require("" + "./manage-columns-dialog");
        }
        this.dialogClientService.show(DialogServiceConstants.URLs.ColumnOptionsDialog, this);
    };
    QueriesEditor.prototype.onSaveManageColumns = function () {
        this.dispatchEvent(QueriesEditorEvents.saveManageColumns);
    };
    QueriesEditor.prototype.navigateToAddRoute = function () {
        var _this = this;
        var route = Enumerable.from(this.router.routes).firstOrDefault(function (x) { return x.name == _this.addRoute; });
        var routeName = route
            ? Array.isArray(route.route)
                ? route.route[0]
                : route.route
            : null;
        if (this.router.hasRoute(routeName)) {
            this.router.navigate(routeName);
        }
        else if (route && route.name) {
            this.router.navigateToRoute(route.name, this.getParams ? this.getParams(null) : null);
        }
        else if (this.addRoute) {
            this.router.navigateToRoute(this.addRoute, this.getParams(null));
        }
        this.dispatchEvent(QueriesEditorEvents.createEntity);
    };
    QueriesEditor.prototype.entityUriChanged = function () {
        this.bind();
    };
    QueriesEditor.prototype.bind = function () {
        var _this = this;
        if (this.activateInternalCalled || !this.entityUri) {
            return;
        }
        this.loadEntityModels(function (x) {
            _this.cache
                .get(CacheKeys.selectedFilters, CacheLocation.SessionStorage)
                .then(function (queryConfig) {
                if (queryConfig) {
                    var config = queryConfig;
                    config.queryFilters.forEach(function (x) {
                        return _this.selectedFilters.push(x);
                    });
                    _this.columns = [];
                    config.columns.forEach(function (x) {
                        return _this.columns.push(x);
                    });
                    _this.cache.remove(CacheKeys.selectedFilters, CacheLocation.SessionStorage);
                    setTimeout(function () { return _this.reloadData(); });
                }
                else {
                    setTimeout(function () {
                        if (!_this.queryId || _this.queryId <= 0) {
                            _this.newQuery();
                        }
                        else {
                            var queriesFound = _this.savedQueries.filter(function (z) { return z.queryId == _this.queryId; });
                            _this.selectedSavedQuery =
                                queriesFound.length > 0 ? queriesFound[0] : null;
                            if (!_this.selectedSavedQuery) {
                                _this.newQuery();
                            }
                        }
                    });
                }
            });
        });
    };
    QueriesEditor.prototype.activateInternal = function (selected, func) {
        var _this = this;
        this.activateInternalCalled = true;
        this.initQueries();
        for (var i = 1; i <= this.selectedFilters.length; i++) {
            this.selectedFilters.splice(0, 1);
        }
        this.entityUri = selected;
        this.loadEntityModels(function (x) {
            setTimeout(function () {
                _this.newQuery();
                if (func) {
                    func();
                }
            });
        });
    };
    QueriesEditor.prototype.dispatchDataGridReload = function () {
        this.dispatchEvent(QueriesEditorEvents.dataGridReload, null);
    };
    QueriesEditor.generateDefaultColumn = function (property, model) {
        var column = {
            name: property.name,
            title: property.friendlyName,
            dataType: property.type,
            isHidden: window.location.pathname == "/transactions" && (property.name == "ticketDrawId" || property.name == "transactionStatus" || property.name == "fileName" || property.name == "insuranceFileStatus") ? true : !property.showByDefault,
            isFilterable: true,
            isSortable: false,
            isGrouping: false,
            sortOrder: 0,
            groupOrder: 0,
            columnOrder: 0
        };
        if (column.isAscending == null &&
            property.defaultOrdering == ProjectionPropertyOrdering.Ascending) {
            column.isAscending = true;
            column.isSortable = true;
        }
        if (column.isAscending == null &&
            property.defaultOrdering == ProjectionPropertyOrdering.Descending) {
            column.isAscending = false;
            column.isSortable = true;
        }
        if ((property.type === DataType.Date || property.type === DataType.DateTime) && !column.valueConverter) {
            column.valueConverter = QueriesEditor_1.getDateFilterFunc(property);
            column.secondParameter = property.format;
        }
        column.isDynamicProperty = property.isDynamicProperty;
        var projectedProperty = model.projectionProperties.filter(function (x) { return x.name == column.name; })[0];
        var filterProperty = model.filterProperties.filter(function (x) { return x.name == column.name; })[0];
        if (filterProperty && projectedProperty && filterProperty.lookupMappedToProperty) {
            column.parameter = filterProperty.lookupMappedToProperty;
        }
        var filterPropertyLookup = model.filterProperties.find(function (x) {
            return (projectedProperty.filterPropertyName && x.name.toLocaleLowerCase() == projectedProperty.filterPropertyName.toLocaleLowerCase()) ||
                x.name.replace("Id", "").toLocaleLowerCase() == column.name.toLocaleLowerCase() &&
                    x.type == DataType.Lookup &&
                    column.dataType == DataType.Default;
        });
        if (filterPropertyLookup) {
            if (!column.filters) {
                column.filters = [];
            }
            column.filters.push({
                filterOperator: { translatedSymbol: "eq" },
                filterProperty: {
                    name: filterPropertyLookup.name,
                    isDynamicProperty: filterPropertyLookup.isDynamicProperty,
                    type: filterPropertyLookup.type,
                    lookupMappedToProperty: filterPropertyLookup.lookupMappedToProperty
                },
                filterValue: null,
                isAnd: true,
                skipOnNullOrEmpty: true
            });
        }
        return column;
    };
    QueriesEditor.prototype.selectedModelLoaded = function (func) {
        var e_1, _a;
        var _this = this;
        var columns = [];
        try {
            for (var _b = __values(this.selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                var column = QueriesEditor_1.generateDefaultColumn(item, this.selectedModel);
                columns.push(column);
                this.dispatchEvent(QueriesEditorEvents.columnPushed, column);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.dispatchEvent(QueriesEditorEvents.columnsPrepared, columns);
        this.columns = columns;
        this.selectedFilters.forEach(function (filter) {
            if (filter.subscription) {
                filter.subscription.dispose();
            }
        });
        this.selectedFilters.splice(0, this.selectedFilters.length);
        setTimeout(function () {
            if (_this.queryBuilder) {
                _this.queryBuilder.reComputeIsLast();
            }
            if (func) {
                func();
            }
        });
    };
    QueriesEditor.prototype.getColumnsFromQuery = function (query) {
        var e_2, _a, e_3, _b;
        var columns = this.fixedColumns ? Enumerable.from(this.fixedColumns).toArray() : [];
        try {
            for (var _c = __values(this.selectedModel.projectionProperties), _d = _c.next(); !_d.done; _d = _c.next()) {
                var item = _d.value;
                var column = QueriesEditor_1.generateDefaultColumn(item, this.selectedModel);
                columns.push(column);
                this.dispatchEvent(QueriesEditorEvents.columnPushed, column);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var savedColumns = query.columns.concat(this.fixedColumns ? Enumerable.from(this.fixedColumns).toArray() : []);
        var _loop_1 = function (x) {
            var currentColumn = Enumerable.from(savedColumns).firstOrDefault(function (z) { return z.name === x.name; });
            x.isHidden = currentColumn ? currentColumn.isHidden : false;
            x.sortOrder = currentColumn ? currentColumn.sortOrder : 0;
            x.groupOrder = currentColumn ? currentColumn.groupOrder : 0;
            x.isSortable = currentColumn ? currentColumn.isSortable : false;
            x.isGrouping = currentColumn ? currentColumn.isGrouping : false;
            x.columnOrder = currentColumn ? currentColumn.columnOrder : 0;
            x.isAscending = currentColumn ? currentColumn.isAscending : true;
        };
        try {
            for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
                var x = columns_1_1.value;
                _loop_1(x);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (columns_1_1 && !columns_1_1.done && (_b = columns_1.return)) _b.call(columns_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.dispatchEvent(QueriesEditorEvents.columnsPrepared, columns);
        return columns;
    };
    QueriesEditor.prototype.reloadData = function (force) {
        var _this = this;
        if (force === void 0) { force = false; }
        if (!this.selectedModel)
            return;
        var uri = !(this.baseUri && this.baseUri.trim().length > 0)
            ? "odata/" + this.selectedModel.uri + (location.href.split("?$filter").length > 1
                ? "?" + location.href.split("?")[1]
                : "")
            : this.baseUri;
        var filters = this.selectedFilters
            .filter(function (x) { return x.filterProperty && x.filterOperator; })
            .concat(this.fixedFilters ? this.fixedFilters : []);
        if (filters.length == 0) {
            filters = [];
        }
        var query = this._selectedSavedQuery
            ? this._selectedSavedQuery
            : this.savedQueries.filter(function (sq) { return sq.queryId == -1; })[0];
        var columns = this.getColumnsFromQuery(query);
        var itemSource = {
            source: uri,
            sourceType: SourceType.ODataUrl,
            getGroupName: this.getGroupName,
            columns: columns,
            initialFilters: filters,
            groupInitialFilters: true,
            propertyDefaults: this.gridSettings,
            limit: this.limit
        };
        if (!this.areEqualSources(this.itemSource, itemSource) || force) {
            if (this.selectedConfigurationEntity &&
                this.selectedConfigurationEntity.converters) {
                columns.forEach(function (col) {
                    var converter = _this.selectedConfigurationEntity.converters.filter(function (x) { return x.property == col.name; })[0];
                    if (converter) {
                        col.valueConverter = function (value, item) {
                            return converter.func(value, item, null);
                        };
                    }
                });
            }
            this.itemSource = itemSource;
        }
    };
    QueriesEditor.prototype.areEqualSources = function (source1, source2) {
        if (source2 != source1 && (!source1 || !source2)) {
            return false;
        }
        var replacer = function (k, v) {
            if (k === "filters") {
                return undefined;
            }
            return v;
        };
        var areEqualUrl = source1.source == source2.source;
        var areEqualSourceType = source1.sourceType == source2.sourceType;
        var areEqualGroupInitialFilters = source1.groupInitialFilters == source2.groupInitialFilters;
        var areEqualInitialFilters = JSON.stringify(source1.initialFilters) ==
            JSON.stringify(source2.initialFilters);
        var areEqualColumns = JSON.stringify(source1.columns, replacer) ==
            JSON.stringify(source2.columns, replacer);
        return (areEqualUrl &&
            areEqualSourceType &&
            areEqualGroupInitialFilters &&
            areEqualInitialFilters &&
            areEqualColumns);
    };
    QueriesEditor.prototype.showSaveAs = function () {
        this.saveAsVisible = true;
    };
    QueriesEditor.prototype.cancelSaveAs = function () {
        this.saveAsVisible = false;
        this.saveAsText = "";
    };
    QueriesEditor.prototype.select = function (item) {
        this.selected = item;
    };
    QueriesEditor.prototype.newQuery = function () {
        var _this = this;
        this.queryId = null;
        var queryFilters = [];
        var columns = [];
        this.selectedModel.projectionProperties.forEach(function (item) {
            var column = QueriesEditor_1.generateDefaultColumn(item, _this.selectedModel);
            if ((item.type === DataType.Date || item.type === DataType.DateTime) && !column.valueConverter) {
                column.valueConverter = QueriesEditor_1.getDateFilterFunc(item);
            }
            columns.push(column);
            _this.dispatchEvent(QueriesEditorEvents.columnPushed, column);
        });
        this.dispatchEvent(QueriesEditorEvents.columnsPrepared, columns);
        this.columns = columns;
        this.selectedFilters = queryFilters;
        setTimeout(function () {
            if (_this.queryBuilder &&
                (!_this.queryBuilder.clauses || _this.queryBuilder.clauses.length == 0)) {
                _this.queryBuilder.addFilter(null);
            }
            _this.reloadData();
        });
    };
    QueriesEditor.prototype.saveAs = function () {
        var e_4, _a;
        var queriesToSave = new Array();
        this.saveAsVisible = false;
        var qm = CloneUtility.clone(this.selectedModel);
        var qf = new Array();
        try {
            for (var _b = __values(this.selectedFilters), _c = _b.next(); !_c.done; _c = _b.next()) {
                var x = _c.value;
                qf.push(CloneUtility.clone(x));
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        var tempId = Guid.generateGuid();
        var query = new SavedQueriesDataModel(this.saveAsText, qm, qf, 0, 0, this.getCreatedForId ? this.getCreatedForId() : 0, false, new Date(), this.itemSource.columns, tempId);
        queriesToSave.push(query);
        if (!this.savedQueries) {
            this.initQueries();
        }
        this.saveAsText = "";
        this.savedQueries.push(query);
        return this.persistQuery(queriesToSave, null, "saved");
    };
    QueriesEditor.prototype.initQueries = function () {
        this.savedQueries = [
            {
                queryId: -1,
                name: " "
            }
        ];
    };
    QueriesEditor.prototype.selectedSavedQueryChanged = function () {
        var e_5, _a, e_6, _b, e_7, _c;
        var selectedSavedQuery = this.selectedSavedQuery;
        if (selectedSavedQuery) {
            this.dispatchEvent(QueriesEditorEvents.savedQueryChanged, {
                queryId: selectedSavedQuery.queryId
            });
        }
        if (selectedSavedQuery && selectedSavedQuery.queryId !== -1) {
            var qm = CloneUtility.clone(selectedSavedQuery.queryModel);
            this.selectedModel = qm;
            this.selectedFilters.forEach(function (filter) {
                if (filter.subscription) {
                    filter.subscription.dispose();
                }
            });
            this.selectedFilters.splice(0, this.selectedFilters.length);
            try {
                for (var _d = __values(selectedSavedQuery.queryFilters), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var x = _e.value;
                    this.selectedFilters.push(QueryFilter.clone(x));
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_5) throw e_5.error; }
            }
            var columns = [];
            try {
                for (var _f = __values(this.selectedModel.projectionProperties), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    var column = QueriesEditor_1.generateDefaultColumn(item, this.selectedModel);
                    columns.push(column);
                    this.dispatchEvent(QueriesEditorEvents.columnPushed, column);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_6) throw e_6.error; }
            }
            var savedColumns = Enumerable.from(selectedSavedQuery.columns);
            var _loop_2 = function (x) {
                var currentColumn = savedColumns.firstOrDefault(function (z) { return z.name === x.name; });
                x.isHidden = currentColumn ? currentColumn.isHidden : false;
                x.sortOrder = currentColumn ? currentColumn.sortOrder : 0;
                x.groupOrder = currentColumn ? currentColumn.groupOrder : 0;
                x.isSortable = currentColumn ? currentColumn.isSortable : false;
                x.isGrouping = currentColumn ? currentColumn.isGrouping : false;
                x.columnOrder = currentColumn ? currentColumn.columnOrder : 0;
                x.isAscending = currentColumn ? currentColumn.isAscending : true;
                x.isDynamicProperty = currentColumn ? currentColumn.isDynamicProperty : false;
                var property = this_1.selectedModel.projectionProperties.filter(function (prop) { return prop.name == x.name; })[0];
                if (property && (property.type === DataType.Date || property.type === DataType.DateTime) && !x.valueConverter) {
                    x.valueConverter = QueriesEditor_1.getDateFilterFunc(property);
                }
                if (this_1.selectedConfigurationEntity && this_1.selectedConfigurationEntity.converters && currentColumn) {
                    var converter_1 = this_1.selectedConfigurationEntity.converters.filter(function (x) { return x.property == currentColumn.name; })[0];
                    if (converter_1) {
                        x.valueConverter = function (value, item) { return converter_1.func(value, item, null); };
                    }
                }
            };
            var this_1 = this;
            try {
                for (var columns_2 = __values(columns), columns_2_1 = columns_2.next(); !columns_2_1.done; columns_2_1 = columns_2.next()) {
                    var x = columns_2_1.value;
                    _loop_2(x);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (columns_2_1 && !columns_2_1.done && (_c = columns_2.return)) _c.call(columns_2);
                }
                finally { if (e_7) throw e_7.error; }
            }
            this.dispatchEvent(QueriesEditorEvents.columnsPrepared, columns);
            this.columns = columns;
            this.reloadData();
        }
        else if (selectedSavedQuery && selectedSavedQuery.queryId === -1) {
            this.newQuery();
        }
    };
    QueriesEditor.prototype.preview = function () {
        this.reloadData(true);
        this.showDataGrid = true;
    };
    QueriesEditor.prototype.onItemSelected = function (event) {
        if (event.detail.item) {
            this.selectedItem = event.detail.item;
            if (this.clickMode == "single") {
                this.doubleClick(event, true);
            }
        }
    };
    QueriesEditor.prototype.selectedModelChanged = function ($event) {
        this.selectedModel = $event.detail;
    };
    QueriesEditor.prototype.doubleClick = function (event, raisedManually) {
        if ((raisedManually && this.clickMode == "single") ||
            this.clickMode == "double") {
            if (!event.detail.item) {
                return;
            }
            this.dispatchEvent(QueriesEditorEvents.rowSelected, event.detail);
            this.selectedItem = event.detail.item;
            var route = this.onRowSelected
                ? this.onRowSelected(this.selectedItem)
                : this.editRoute
                    ? this.editRoute
                    : null;
            if (typeof route == "string") {
                var params = this.getParams(this.selectedItem);
                this.router.navigateToRoute(route, params);
            }
            else if (typeof route == "function") {
                route(this.selectedItem, this.router);
            }
        }
    };
    QueriesEditor.prototype.save = function () {
        var e_8, _a, e_9, _b;
        var selectedSavedQuery = this.selectedSavedQuery;
        if (selectedSavedQuery) {
            var queriesToSave = new Array();
            var qm = CloneUtility.clone(this.selectedModel);
            var qf = new Array();
            try {
                for (var _c = __values(this.selectedFilters), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var x = _d.value;
                    qf.push(CloneUtility.clone(x));
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_8) throw e_8.error; }
            }
            var queryToUpdate = Enumerable.from(queriesToSave).firstOrDefault(function (x) { return JSON.stringify(x) === JSON.stringify(selectedSavedQuery); });
            if (queryToUpdate) {
                queryToUpdate.queryModel = qm;
                queryToUpdate.queryFilters = qf;
            }
            else {
                selectedSavedQuery.queryModel = qm;
                selectedSavedQuery.queryFilters = qf;
                queriesToSave.push(selectedSavedQuery);
            }
            selectedSavedQuery.queryModel = qm;
            selectedSavedQuery.queryFilters = qf;
            selectedSavedQuery.columns = this.itemSource.columns;
            var _loop_3 = function (query) {
                query.tempId = Guid.generateGuid();
                var inCollection = this_2.savedQueries.filter(function (x) { return x.queryId == query.queryId; })[0];
                if (inCollection) {
                    inCollection.tempId = query.tempId;
                }
            };
            var this_2 = this;
            try {
                for (var queriesToSave_1 = __values(queriesToSave), queriesToSave_1_1 = queriesToSave_1.next(); !queriesToSave_1_1.done; queriesToSave_1_1 = queriesToSave_1.next()) {
                    var query = queriesToSave_1_1.value;
                    _loop_3(query);
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (queriesToSave_1_1 && !queriesToSave_1_1.done && (_b = queriesToSave_1.return)) _b.call(queriesToSave_1);
                }
                finally { if (e_9) throw e_9.error; }
            }
            return this.persistQuery(queriesToSave, null, "saved");
        }
        else {
            return this.saveAs();
        }
    };
    QueriesEditor.prototype.delete = function () {
        var selectedSavedQuery = this.selectedSavedQuery;
        if (selectedSavedQuery) {
            var index = this.savedQueries.indexOf(selectedSavedQuery);
            var queriesToRemove = new Array();
            if (selectedSavedQuery.queryId > 0) {
                queriesToRemove.push(selectedSavedQuery.queryId);
            }
            this.savedQueries.splice(index, 1);
            if (this.queryId) {
                this.queryId = null;
            }
            else {
                this.queryId = -1;
            }
            this.persistQuery(null, queriesToRemove, "deleted");
            this.newQuery();
        }
    };
    QueriesEditor.prototype.persistQuery = function (queriesToSave, queriesToRemove, saveOrDelete) {
        var _this = this;
        console.log('closing QueryManager...');
        var hasWork = (queriesToSave && queriesToSave.length > 0) ||
            (queriesToRemove && queriesToRemove.length > 0);
        if (!hasWork) {
            return Promise.resolve(null);
        }
        queriesToSave = queriesToSave !== null && queriesToSave !== void 0 ? queriesToSave : [];
        queriesToRemove = queriesToRemove !== null && queriesToRemove !== void 0 ? queriesToRemove : [];
        var payload = Enumerable.from(queriesToSave)
            .select(function (x) {
            return new Query(x.queryId, x.queryModel.uri, x.name, x.isSharedGlobally, x.dateCreated, JSON.stringify(x.queryFilters), x.createdById, JSON.stringify(x.columns), x.tempId);
        })
            .toArray();
        var promise = toNative(this.queriesService.persistQueries(payload, queriesToRemove));
        promise.then(function (result) {
            // update ids from the server response
            var enumerable = Enumerable.from(_this.savedQueries);
            var _loop_4 = function (tempId) {
                var queryToUpdate = enumerable.firstOrDefault(function (x) { return x.tempId === tempId; });
                if (queryToUpdate) {
                    queryToUpdate.queryId = result.savedQueries[tempId];
                    _this.queryId = queryToUpdate.queryId;
                }
            };
            for (var tempId in result.savedQueries) {
                _loop_4(tempId);
            }
        });
        return promise;
    };
    QueriesEditor.prototype.hasSharedGloballyPermission = function () {
        return UserRoleAndClaimsHelper.HasShareQueriesGloballyPermission(this.userClientService.currentUser.allowedClaims);
    };
    QueriesEditor.prototype.loadSavedQueries = function () {
        var _this = this;
        var promise = this.queriesService.getQueriesForUser(this.selectedModel.uri);
        return new Promise(function (resolve, reject) {
            promise.then(function (result) {
                var e_10, _a;
                var queries = result.queries;
                if (!_this.savedQueries) {
                    _this.initQueries();
                }
                var queriesList = [
                    {
                        queryId: -1,
                        name: " ",
                        columns: []
                    }
                ];
                if (_this.models) {
                    var _loop_5 = function (query) {
                        var qm = Enumerable.from(_this.models).where(function (x) { return x.uri != null; }).firstOrDefault(function (x) { return x.uri === query.queryName; });
                        var qf = JSON.parse(query.queryBody);
                        queriesList.push(new SavedQueriesDataModel(query.description, qm, qf, query.queryId, query.createdById, null, query.isSharedGlobally, query.dateCreated, JSON.parse(query.columns), ""));
                    };
                    try {
                        for (var queries_1 = __values(queries), queries_1_1 = queries_1.next(); !queries_1_1.done; queries_1_1 = queries_1.next()) {
                            var query = queries_1_1.value;
                            _loop_5(query);
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (queries_1_1 && !queries_1_1.done && (_a = queries_1.return)) _a.call(queries_1);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                }
                _this.savedQueries = queriesList;
                resolve();
            }, function (error) {
                reject(error);
            });
        });
    };
    QueriesEditor.prototype.loadEntityModels = function (func) {
        var _this = this;
        var action = function () {
            //load model before lodaing queries to use uri since the type and uri is different on some
            _this.selectedModel = Enumerable.from(_this.models).firstOrDefault(function (y) { return y.uri && y.uri.toLowerCase() == _this.entityUri.toLowerCase(); });
            _this.selectedConfigurationEntity = AllEntityTypeConfigurationConstants.filter(function (x) {
                return x.uri &&
                    _this.selectedModel.uri &&
                    x.uri.replace(/\s/g, "").toLowerCase() ==
                        _this.selectedModel.uri.replace(/\s/g, "").toLowerCase();
            })[0];
            _this.loadSavedQueries().then(function (x) {
                _this.selectedModel = Enumerable.from(_this.models).firstOrDefault(function (y) { return y.uri && y.uri.toLowerCase() === _this.entityUri.toLowerCase(); });
                _this.selectedConfigurationEntity = AllEntityTypeConfigurationConstants.filter(function (x) {
                    return x.uri &&
                        _this.selectedModel.uri &&
                        x.uri.replace(/\s/g, "").toLowerCase() ==
                            _this.selectedModel.uri.replace(/\s/g, "").toLowerCase();
                })[0];
                _this.selectedModelLoaded(func);
                var query = _this.savedQueries.filter(function (sq) { return sq.queryId == -1; })[0];
                query.columns = [];
                _this.selectedModel.projectionProperties.forEach(function (p) {
                    var column = QueriesEditor_1.generateDefaultColumn(p, _this.selectedModel);
                    query.columns.push(column);
                    _this.dispatchEvent(QueriesEditorEvents.columnPushed, column);
                });
            });
        };
        if (this.metaDataLoaded) {
            action();
        }
        else {
            this.queriesService.getEntityModels().then(function (models) {
                _this.models = models;
                action();
            }, function (error) {
                _this.notificationService.show(_this.i18N.tr("error-text") + "!", _this.i18N.tr("error-loading-meta-data-for-query-editor-text"), NotificationType.Error);
            });
        }
    };
    QueriesEditor.prototype.dispatchEvent = function (nameEvent, data) {
        if (this.element && nameEvent) {
            var customEvent = new CustomEvent(nameEvent, {
                bubbles: true,
                detail: data
            });
            this.element.dispatchEvent(customEvent);
        }
    };
    QueriesEditor.getDateFilterFunc = function (property) {
        return function (value) {
            if (!value) {
                return "";
            }
            var format = property.format ? property.format : (property.type == DataType.DateTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY");
            if (property.type == DataType.DateTime) {
                return moment(value).format(format);
            }
            else {
                return moment.utc(value).format(format);
            }
        };
    };
    var QueriesEditor_1;
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueriesEditor.prototype, "title", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueriesEditor.prototype, "showDataGrid", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueriesEditor.prototype, "showPreviewButton", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], QueriesEditor.prototype, "pageCount", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], QueriesEditor.prototype, "limit", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], QueriesEditor.prototype, "queryId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], QueriesEditor.prototype, "getCreatedForId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueriesEditor.prototype, "enableUploadExcel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueriesEditor.prototype, "enableDownloadExcel", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueriesEditor.prototype, "clickMode", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueriesEditor.prototype, "addRoute", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueriesEditor.prototype, "hideGrouping", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], QueriesEditor.prototype, "editRoute", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], QueriesEditor.prototype, "getParams", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], QueriesEditor.prototype, "onRowSelected", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueriesEditor.prototype, "addNewText", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueriesEditor.prototype, "baseUri", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], QueriesEditor.prototype, "entityUri", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], QueriesEditor.prototype, "sortAlphabetically", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], QueriesEditor.prototype, "fixedColumns", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], QueriesEditor.prototype, "fixedFilters", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], QueriesEditor.prototype, "gridSettings", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], QueriesEditor.prototype, "getGroupName", void 0);
    __decorate([
        computedFrom('selectedModel'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QueriesEditor.prototype, "dataGridClass", null);
    QueriesEditor = QueriesEditor_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element,
            NotificationClientService,
            QueriesClientService,
            DialogClientService,
            Router,
            CacheClient,
            I18N,
            UserClientService])
    ], QueriesEditor);
    return QueriesEditor;
}());
export { QueriesEditor };
